import {Component, OnInit} from '@angular/core';
import {CodaltComponent} from '../../codalt.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {Utils} from '../../utils.class';
import {Routenames} from '../../route-names.enum';
import {MoldMaterial} from '../../mold-material';
import {MoldService} from '../../services/mold.service';

@Component({
    selector: 'app-mold-material-edit',
    templateUrl: './mold-material-edit.component.html',
    styleUrls: ['./mold-material-edit.component.scss']
})
export class MoldMaterialEditComponent extends CodaltComponent implements OnInit {

    fc: {
        name: FormControl
    };

    form: FormGroup;

    material: MoldMaterial;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private confirmDialog: ConfirmDialogService,
                private moldService: MoldService) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(this.route.params.subscribe(params => {
            this.moldService.getMaterial(params['id']).subscribe(equipment => {
                this.material = equipment.data || new MoldMaterial();
                this.fc = {
                    name: new FormControl(this.material.name, Validators.required)
                };
                this.form = new FormGroup(this.fc);
            });
        }));
    }

    save() {
        Utils.triggerValidation(this.form);
        if (this.form.valid) {
            this.material.name = this.fc.name.value;
            this.moldService.saveMaterial(this.material).subscribe(() => {
                this.router.navigate([Routenames.moldMaterial]);
            }, error => {
                this.confirmDialog.confirm(
                    'Fout bij het opslaan',
                    error.message,
                    'Sluiten'
                ).then(() => {

                }, () => {

                });
            });
        }
    }
}
